module.exports = {"1":{"F":["Ground Floor","0","1","2","3","4","5","6","7","8","9","10","11","12","13","Roof"],"H":["Ground Floor","0","1","2","3","4","5","6","7","8","Roof"]},"2":{"B":["TBC"],"D":["TBC"]},"3":{"E":["Ground Floor","0","1","2","3","4","5","6","7","8","9","10","11","12","13","Roof"],"G":["Ground Floor","0","1","2","3","4","5","6","7","8","Roof"]},"4":{"A":["TBC"],"C":["TBC"]},"Site Wide":["Other (specify below)"],"Completed Area (Estates)":["Other (specify below)"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/suttonGardenSquare.json
// module id = 130
// module chunks = 0